function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsxs as D, Fragment as L, jsx as c } from "react/jsx-runtime";
import * as l from "react";
import O from "classnames";
import { debounce as W } from "./utils/helpers.js";
import { isRunningAcceptanceTest as k } from "./utils/platform.js";
import { useScreenSize as z, useTheme as N, useElementDimensions as P, useWindowHeight as $, useScreenHeight as j, useIsomorphicLayoutEffect as _, useIsWithinIFrame as B } from "./hooks.js";
import { getScrollableParentElement as H, addPassiveEventListener as v, removePassiveEventListener as h, hasScroll as V, getScrollDistanceToBottom as q } from "./utils/dom.js";
import { container as G, vars as E, footer as J, withoutFooter as K, elevated as M, fixedFooter as Q } from "./fixed-footer-layout.css-mistica.js";
import { assignInlineVars as U } from "@vanilla-extract/dynamic";
const X = 2, Y = (e)=>e === document.documentElement ? window : e, Z = (e)=>{
    const n = setTimeout(e, 0);
    return {
        cancel: ()=>clearTimeout(n)
    };
}, C = (param)=>{
    let { isFooterVisible: e = !0 , footer: n , footerHeight: x = "auto" , footerBgColor: S , containerBgColor: m , children: T , onChangeFooterHeight: o  } = param;
    const [g, y] = l.useState(!1), u = l.useRef(null), { isTabletOrSmaller: w  } = z(), { platformOverrides: d  } = N(), { height: s , ref: F  } = P(), b = B(), f = $(), I = j(), i = f - s > (b ? f : I) / X;
    _(()=>{
        o == null || o(s);
    }, [
        o,
        s
    ]), l.useEffect(()=>{
        const a = H(u.current), R = ()=>k(d) || !i ? !1 : V(a) ? q(a) > 1 : !1, t = W(()=>{
            y(R());
        }, 50, {
            leading: !0,
            maxWait: 200
        }), A = Z(t), r = Y(a);
        return v(r, "resize", t), v(r, "scroll", t), ()=>{
            t.cancel(), h(r, "scroll", t), h(r, "resize", t), A.cancel();
        };
    }, [
        i,
        d
    ]);
    const p = i;
    return /* @__PURE__ */ D(L, {
        children: [
            /* @__PURE__ */ c("div", {
                ref: u,
                className: G,
                style: U(_object_spread_props(_object_spread({}, m && {
                    [E.backgroundColor]: m
                }), {
                    [E.footerHeight]: p ? `${s}px` : "0px"
                })),
                children: T
            }),
            /* @__PURE__ */ c("div", {
                className: O(J, {
                    [K]: !e,
                    [M]: g,
                    [Q]: p
                }),
                style: {
                    background: w ? S : void 0
                },
                "data-testid": `fixed-footer${e ? "-visible" : "-hidden"}`,
                "data-position-fixed": "bottom",
                children: e && /* @__PURE__ */ c("aside", {
                    ref: F,
                    "data-component-name": "FixedFooter",
                    style: {
                        height: x,
                        marginBottom: "env(safe-area-inset-bottom)"
                    },
                    children: n
                })
            })
        ]
    });
}, ce = C;
export { ce as default };
